/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import NewsError from './NewsError';

/**
 * NewsError module exports
 */
export { NewsError as default };



// WEBPACK FOOTER //
// ./src/js/News/components/NewsError/index.js